import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const GradeAPage = lazy(() => import('../pages/pallets/grade-a/page'));
const GradeBPage = lazy(() => import('../pages/pallets/grade-b/page'));
const NewPalletsPage = lazy(() => import('../pages/pallets/new/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/pallets/grade-a',
    element: <GradeAPage />,
  },
  {
    path: '/pallets/grade-b',
    element: <GradeBPage />,
  },
  {
    path: '/pallets/new',
    element: <NewPalletsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;